var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
var Flex = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  display: flex;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), function (_a) {
    var direction = _a.direction;
    return direction && "flex-direction: " + direction + ";";
}, function (_a) {
    var flex = _a.flex;
    return flex && "flex: " + flex + ";";
}, function (_a) {
    var wrap = _a.wrap;
    return wrap && "flex-wrap: " + wrap + ";";
}, function (_a) {
    var justifyContent = _a.justifyContent;
    return justifyContent && "justify-content: " + justifyContent + ";";
}, function (_a) {
    var alignItems = _a.alignItems;
    return alignItems && "align-items: " + alignItems + ";";
}, function (_a) {
    var alignContent = _a.alignContent;
    return alignContent && "align-content: " + alignContent + ";";
}, function (_a) {
    var maxWidth = _a.maxWidth;
    return maxWidth && "max-width: " + maxWidth + ";";
}, function (_a) {
    var margin = _a.margin;
    return margin && "margin: " + margin + ";";
}, function (_a) {
    var padding = _a.padding;
    return padding && "padding: " + padding + ";";
}, function (_a) {
    var height = _a.height;
    return height && "height: " + height + ";";
}, function (_a) {
    var width = _a.width;
    return width && "width: " + width + ";";
});
export default Flex;
var templateObject_1;
